import type {
  DocumentAcknowledgementItem,
  DocumentResponsibilityEntry,
} from '../types/document.types'
import { formatShortName } from '@/utils/formatters'

const COMPLETED_STATUSES = new Set(['completed', 'passed'])

function unwrapEntries(
  data: DocumentResponsibilityEntry[] | { results?: DocumentResponsibilityEntry[] } | null | undefined,
): DocumentResponsibilityEntry[] {
  if (!data)
    return []
  if (Array.isArray(data))
    return data

  return Array.isArray(data.results) ? data.results : []
}

function isAcknowledged(entry: DocumentResponsibilityEntry): boolean {
  return COMPLETED_STATUSES.has(String(entry.status || '').toLowerCase())
}

function resolveAcknowledgedAt(entry: DocumentResponsibilityEntry): string | null {
  if (!isAcknowledged(entry))
    return null

  return entry.updated_at || entry.read_at || entry.created_at || null
}

export function mapDocumentResponsibilityEntry(
  entry: DocumentResponsibilityEntry,
): DocumentAcknowledgementItem {
  const employee = entry.responsible_employee

  return {
    id: entry.id,
    employeeId: employee?.id ?? null,
    employeeName: formatShortName(employee) || '—',
    departmentName: employee?.department_name?.trim() || '—',
    acknowledgedAt: resolveAcknowledgedAt(entry),
    status: isAcknowledged(entry) ? 'acknowledged' : 'pending',
    actions: entry.actions,
  }
}

/** Лист ознакомления: только acknowledgment, иначе все записи списка */
export function mapDocumentFamiliarizers(
  data: DocumentResponsibilityEntry[] | { results?: DocumentResponsibilityEntry[] } | null | undefined,
): DocumentAcknowledgementItem[] {
  const entries = unwrapEntries(data)
  const acknowledgments = entries.filter(
    entry => String(entry.type || '').toLowerCase() === 'acknowledgment',
  )
  const source = acknowledgments.length ? acknowledgments : entries

  return source.map(mapDocumentResponsibilityEntry)
}
